import { FEATURE_CARDS } from '../HostfullyAssistMarketing.constants';
import {
  BlueSubtleSection,
  CARD_BACKGROUND,
  CardGrid,
  SectionInner,
} from '../HostfullyAssistMarketing.styles';
import MarketingContentCard from './MarketingContentCard';

const FeaturesSection = () => {
  return (
    <BlueSubtleSection data-testid="assist-features">
      <SectionInner>
        <CardGrid $columns={3}>
          {FEATURE_CARDS.map((card) => (
            <MarketingContentCard
              key={card.testId}
              card={card}
              background={CARD_BACKGROUND}
            />
          ))}
        </CardGrid>
      </SectionInner>
    </BlueSubtleSection>
  );
};

export default FeaturesSection;
